import styled from "@emotion/styled";
import { Button, Card, css, Typography } from "@mui/material";
import { mobile } from "commons/styled.components";

export const ShoppingCard = styled(Card)`
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.12);
  }
`;

export const CardContent = styled.div`
  position: relative;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: stretch;
`;

export const BrandImage = styled.img`
  width: 100%;
  height: 10rem;
  object-fit: cover;
  object-position: center;
  border-radius: 4px;
`;

export const BrandName = styled(Typography)`
  font-size: 1rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1a1a1a;
`;

export const CashBackBadge = styled.span`
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #e8f5e9;
`;

export const CashBackBadgeText = styled(Typography)`
  font-size: 11px;
  font-weight: 600;
  color: #2e7d32;
`;

export const CashBackRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CashBackLabel = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  color: #727272;
`;

export const CashBackValue = styled(Typography)`
  font-size: 13px;
  font-weight: 600;
  color: #2e7d32;
`;

export const GetOfferButton = styled(Button)`
  color: #fff;
  background-color: #1a1a1a;
  border-radius: 6px;
  padding: 6px 0;
  text-transform: none;
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;

  &:hover {
    background-color: #333;
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 280px));
  gap: 1.5rem;

  ${mobile(css`
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
  `)}
`;
